import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailRequest } from '../models/emailrequest.model';
import { ERPSubmissionAttempt } from '../models/erpsubmissionattempt.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ErpsubmissionattemptService {

	private svcUrl = '/ERPSubmissionAttempts';

	constructor(private http: HttpClient, private url: UrlService) { }

	getERPSubmissionAttempt(id: number): Observable<ERPSubmissionAttempt> {
		return this.http.get<ERPSubmissionAttempt>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	getERPSubmissionAttemptsForBrokerId(id: number, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0 : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ERPSubmissionAttempt[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id, { params });
	}

	getERPSubmissionAttemptsForUserId(id: string, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0 : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ERPSubmissionAttempt[]>(this.url.getBaseURL() + this.svcUrl + '/User/' + id, { params });
	}

	getERPSubmissionAttemptsForParsedEmailId(id: number, isDismissed?: boolean | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed));
		return this.http.get<ERPSubmissionAttempt[]>(this.url.getBaseURL() + this.svcUrl + '/ParsedEmail/' + id, { params });
	}

	getEmailRequestForERPSubmissionAttemptId(id: number) {
		return this.http.get<EmailRequest>(this.url.getBaseURL() + this.svcUrl + '/ERPSubmissionAttempt/' + id);
	}

	dismissERPSubmissionAttempt(id: number): Observable<ERPSubmissionAttempt> {
		return this.http.post<ERPSubmissionAttempt>(this.url.getBaseURL() + this.svcUrl + '/Dismiss/' + id, {});
	}

	createERPSubmissionAttempt(parsedEmailId: number, connId: number, erpStatusId: number): Observable<ERPSubmissionAttempt> {
		// here, erpStatusId is either 0 = quoted or 1 = booked
		return this.http.post<ERPSubmissionAttempt>(this.url.getBaseURL() + this.svcUrl + '/CreateERPSubmissionAttempt/' + parsedEmailId + '/' + connId + '/' + erpStatusId, '{}');
	}

	submitToERP(erpSubmissionAttemptId: number): Observable<ERPSubmissionAttempt> {
		return this.http.post<ERPSubmissionAttempt>(this.url.getBaseURL() + this.svcUrl + '/SubmitToERP/' + erpSubmissionAttemptId, '{}');
	}

}
